module.exports = __webpack_public_path__ + "img/still (29).0324b3dd.jpg";